import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { ConfirmDialogService, ConfirmDialogConfig } from '@core/services/confirm-dialog.service';

@Component({
  standalone: false,
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit, OnDestroy {
  visible = false;
  config: ConfirmDialogConfig = { message: '' };
  private resolveFn: ((v: boolean) => void) | null = null;
  private sub!: Subscription;

  constructor(private confirmService: ConfirmDialogService) {}

  ngOnInit(): void {
    this.sub = this.confirmService.pending$.subscribe(pending => {
      if (pending) {
        this.config = pending.config;
        this.resolveFn = pending.resolve;
        this.visible = true;
      }
    });
  }

  ngOnDestroy(): void { this.sub.unsubscribe(); }

  answer(result: boolean): void {
    this.visible = false;
    this.resolveFn?.(result);
    this.resolveFn = null;
  }
}
